export * from './types/types';
export * from './wrappers/wrappers';
export { FormlyValidationMessage } from './formly.validation-message';
export { FormlyBootstrapModule } from './ui-bootstrap.module';
//# sourceMappingURL=ui-bootstrap.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/ui-bootstrap.js
// module id = 779
// module chunks = 3